import {
    DocumentRequirementFulfilmentType,
    DocumentRequirementStatusType,
} from '@wdx/clmi/clmi-swagger-gen';
import {
    KeyValueObject,
    NavItem,
    TRANSLATION_DOC_CHECKLIST_ADD_TO_ENVELOPE,
    TRANSLATION_DOC_CHECKLIST_APPROVE,
    TRANSLATION_DOC_CHECKLIST_CANCEL,
    TRANSLATION_DOC_CHECKLIST_DELETE,
    TRANSLATION_DOC_CHECKLIST_GATHER,
    TRANSLATION_DOC_CHECKLIST_GENERATE_AND_PROVIDE,
    TRANSLATION_DOC_CHECKLIST_GENERATE_AND_SIGN,
    TRANSLATION_DOC_CHECKLIST_GENERATE_DOCUMENT,
    TRANSLATION_DOC_CHECKLIST_MARK_AS_SENT,
    TRANSLATION_DOC_CHECKLIST_PROVIDE,
    TRANSLATION_DOC_CHECKLIST_PROVIDED,
    TRANSLATION_DOC_CHECKLIST_REJECT,
    TRANSLATION_DOC_CHECKLIST_REQUEST_FROM_CLIENT,
    TRANSLATION_DOC_CHECKLIST_STATUS_ACCEPTED,
    TRANSLATION_DOC_CHECKLIST_STATUS_APPROVED,
    TRANSLATION_DOC_CHECKLIST_STATUS_APPROVED_WITH_CONDITIONS,
    TRANSLATION_DOC_CHECKLIST_STATUS_CANCELLED,
    TRANSLATION_DOC_CHECKLIST_STATUS_GENERATED,
    TRANSLATION_DOC_CHECKLIST_STATUS_PENDING,
    TRANSLATION_DOC_CHECKLIST_STATUS_RECEIVED,
    TRANSLATION_DOC_CHECKLIST_STATUS_REJECTED,
    TRANSLATION_DOC_CHECKLIST_UPLOAD_DOC,
    TRANSLATION_GROUP_BY_CATEGORY,
    TRANSLATION_GROUP_BY_METHOD,
    TRANSLATION_GROUP_BY_RELATED_TO,
    TRANSLATION_GROUP_BY_STATUS,
    TRANSLATION_TABLE_HEADER_CATEGORY,
    TRANSLATION_TABLE_HEADER_DOCS,
    TRANSLATION_TABLE_HEADER_METHOD,
    TRANSLATION_TABLE_HEADER_NAME,
    TRANSLATION_TABLE_HEADER_RELATED_TO,
    TRANSLATION_TABLE_HEADER_STATUS,
    UTILS_ICON_FILE_PLUS,
} from '@wdx/shared/utils';
import {
    ICON_ADD_TO_ENVELOPE,
    ICON_CANCEL,
    ICON_CHECK,
    ICON_DELETE,
    ICON_ENVELOPE_PLUS,
    ICON_EXTERNAL_LINK,
    ICON_UPLOAD,
} from '../../../../constants/icons.constants';
import { ActionButton } from '../../../../models/action-button.model';
import { ActionButtonMode } from '../../../../models/action-buttons-mode.model';
import { ENVELOPE_LOOKUP_MODAL_ID } from '../shared/components/envelope-lookup';
import { DocumentChecklistRelatedToService } from './document-checklist-related-to/document-checklist-related-to.service';
import {
    DocumentChecklistAction,
    DocumentChecklistItem,
} from './document-checklist.model';

const relatedToService = new DocumentChecklistRelatedToService();

const DocumentRequirementFulfilmentTypeName = {
    [DocumentRequirementFulfilmentType.Provide]: 'Provide',
    [DocumentRequirementFulfilmentType.Gather]: 'Gather',
    [DocumentRequirementFulfilmentType.GenerateAndSign]: 'Generate And Sign',
    [DocumentRequirementFulfilmentType.GenerateAndProvide]:
        'Generate And Provide',
};

export const TABLE_HEADERS = [
    {
        label: null,
        key: '',
        classes: 'table-col-checkboxes',
        hidden: false,
        colWidthAll: '5%',
        colWidthOneHidden: '5%',
    },
    {
        label: TRANSLATION_TABLE_HEADER_NAME,
        key: '',
        classes: 'table-col-name',
        hidden: false,
        colWidthAll: '18%',
        colWidthOneHidden: '21%',
    },
    {
        label: TRANSLATION_TABLE_HEADER_DOCS,
        key: '',
        classes: 'table-col-docs',
        hidden: false,
        colWidthAll: '5%',
        colWidthOneHidden: '7%',
    },
    {
        label: TRANSLATION_TABLE_HEADER_CATEGORY,
        key: 'category',
        classes: '',
        hidden: false,
        colWidthAll: '13%',
        colWidthOneHidden: '15%',
    },
    {
        label: TRANSLATION_TABLE_HEADER_METHOD,
        key: 'method',
        classes: '',
        hidden: false,
        colWidthAll: '13%',
        colWidthOneHidden: '15%',
    },
    {
        label: TRANSLATION_TABLE_HEADER_RELATED_TO,
        key: 'relatedTo',
        classes: '',
        hidden: false,
        colWidthAll: '12%',
        colWidthOneHidden: '15%',
    },
    {
        label: TRANSLATION_TABLE_HEADER_STATUS,
        key: '',
        classes: 'table-col-status',
        hidden: false,
        colWidthAll: '18%',
        colWidthOneHidden: '19%',
    },
    {
        label: null,
        key: '',
        classes: 'table-col-comments',
        hidden: false,
        colWidthAll: '8%',
        colWidthOneHidden: '9%',
    },
    {
        label: null,
        key: '',
        classes: 'table-col-actions',
        hidden: false,
        colWidthAll: '8%',
        colWidthOneHidden: '9%',
    },
];

export type ActionTrigger = ActionButton<DocumentChecklistAction> | NavItem;

export const ADD_TO_ENVELOPE_ACTION: NavItem = {
    label: TRANSLATION_DOC_CHECKLIST_ADD_TO_ENVELOPE,
    icon: ICON_ADD_TO_ENVELOPE.icon,
    value: DocumentChecklistAction.AddToEnvelope,
    modalId: ENVELOPE_LOOKUP_MODAL_ID,
};

export const APPROVE_ACTION: ActionTrigger = {
    label: TRANSLATION_DOC_CHECKLIST_APPROVE,
    icon: ICON_CHECK.icon,
    value: DocumentChecklistAction.Approve,
};

export const REJECT_ACTION: ActionTrigger = {
    label: TRANSLATION_DOC_CHECKLIST_REJECT,
    icon: ICON_CANCEL.icon,
    value: DocumentChecklistAction.Reject,
};

export const GENERATE_DOCUMENT_ACTION: ActionTrigger = {
    label: TRANSLATION_DOC_CHECKLIST_GENERATE_DOCUMENT,
    value: DocumentChecklistAction.Generate,
    icon: UTILS_ICON_FILE_PLUS,
};

export const UPLOAD_ACTION: ActionTrigger = {
    label: TRANSLATION_DOC_CHECKLIST_UPLOAD_DOC,
    icon: ICON_UPLOAD.icon,
    value: DocumentChecklistAction.Upload,
};

export const MARK_AS_PROVIDED_ACTION: ActionTrigger = {
    label: TRANSLATION_DOC_CHECKLIST_MARK_AS_SENT,
    icon: ICON_ENVELOPE_PLUS.icon,
    value: DocumentChecklistAction.MarkAsProvided,
};

export const CANCEL_ACTION: ActionTrigger = {
    label: TRANSLATION_DOC_CHECKLIST_CANCEL,
    icon: ICON_CANCEL.icon,
    value: DocumentChecklistAction.Cancel,
};

export const CREATE_EXTERNAL_TASK: ActionTrigger = {
    label: TRANSLATION_DOC_CHECKLIST_REQUEST_FROM_CLIENT,
    icon: ICON_EXTERNAL_LINK.icon,
    value: DocumentChecklistAction.CreateExternalTask,
};

export const DELETE_ACTION: ActionTrigger = {
    label: TRANSLATION_DOC_CHECKLIST_DELETE,
    icon: ICON_DELETE.icon,
    value: DocumentChecklistAction.Delete,
};

export interface GroupByConfig {
    label: string;
    key: string;
    valueMapper: (data: DocumentChecklistItem) => string;
    labelMapper: (data: DocumentChecklistItem) => string;
}

export const DOCUMENT_CHECKLIST_GROUP_BY_MAP: KeyValueObject<GroupByConfig> = {
    category: {
        label: TRANSLATION_GROUP_BY_CATEGORY,
        key: 'category',
        valueMapper: (data: DocumentChecklistItem) =>
            data.documentRequirementType?.category?.value,
        labelMapper: (data: DocumentChecklistItem) =>
            data.documentRequirementType?.category?.label,
    },
    method: {
        label: TRANSLATION_GROUP_BY_METHOD,
        key: 'method',
        valueMapper: (data: DocumentChecklistItem) =>
            data.documentRequirementType?.fulfilmentType,
        labelMapper: (data: DocumentChecklistItem) =>
            DocumentRequirementFulfilmentTypeName[
                data.documentRequirementType?.fulfilmentType
            ],
    },
    relatedTo: {
        label: TRANSLATION_GROUP_BY_RELATED_TO,
        key: 'relatedTo',
        valueMapper: (data: DocumentChecklistItem) =>
            relatedToService.getRelatedTo(data.documentRequirement)?.id,
        labelMapper: (data: DocumentChecklistItem) =>
            relatedToService.getRelatedTo(data.documentRequirement)?.name,
    },
    status: {
        label: TRANSLATION_GROUP_BY_STATUS,
        key: 'status',
        valueMapper: (data: DocumentChecklistItem) =>
            data.documentRequirement?.status,
        labelMapper: (data: DocumentChecklistItem) =>
            data.documentRequirement?.status,
    },
};

export const GROUP_BY_MENU_BUTTON: ActionButton = {
    mode: ActionButtonMode.DropdownButtonMenuWithLabel,
    dropdownMenu: Object.values(DOCUMENT_CHECKLIST_GROUP_BY_MAP).map(
        ({ label, key }) => ({
            value: key,
            label,
        }),
    ),
};

export const SUPPORTED_BULK_ACTIONS = [
    DocumentChecklistAction.Approve,
    DocumentChecklistAction.ApproveWithConditions,
    DocumentChecklistAction.Cancel,
    DocumentChecklistAction.Reject,
    DocumentChecklistAction.Generate,
    DocumentChecklistAction.MarkAsProvided,
    DocumentChecklistAction.AddToEnvelope,
];

export const CANT_ADD_DOCUMENT = [DocumentRequirementStatusType.Cancelled];

export const DOC_REQ_FULFILMENT_TYPE_NAME = {
    [DocumentRequirementFulfilmentType.Provide]:
        TRANSLATION_DOC_CHECKLIST_PROVIDE,
    [DocumentRequirementFulfilmentType.Gather]:
        TRANSLATION_DOC_CHECKLIST_GATHER,
    [DocumentRequirementFulfilmentType.GenerateAndSign]:
        TRANSLATION_DOC_CHECKLIST_GENERATE_AND_SIGN,
    [DocumentRequirementFulfilmentType.GenerateAndProvide]:
        TRANSLATION_DOC_CHECKLIST_GENERATE_AND_PROVIDE,
};
export const DOC_REQ_STATUS_TYPE = {
    [DocumentRequirementStatusType.Pending]:
        TRANSLATION_DOC_CHECKLIST_STATUS_PENDING,
    [DocumentRequirementStatusType.Generated]:
        TRANSLATION_DOC_CHECKLIST_STATUS_GENERATED,
    [DocumentRequirementStatusType.Provided]:
        TRANSLATION_DOC_CHECKLIST_PROVIDED,
    [DocumentRequirementStatusType.Received]:
        TRANSLATION_DOC_CHECKLIST_STATUS_RECEIVED,
    [DocumentRequirementStatusType.Approved]:
        TRANSLATION_DOC_CHECKLIST_STATUS_APPROVED,
    [DocumentRequirementStatusType.Rejected]:
        TRANSLATION_DOC_CHECKLIST_STATUS_REJECTED,
    [DocumentRequirementStatusType.Accepted]:
        TRANSLATION_DOC_CHECKLIST_STATUS_ACCEPTED,
    [DocumentRequirementStatusType.ApprovedWithConditions]:
        TRANSLATION_DOC_CHECKLIST_STATUS_APPROVED_WITH_CONDITIONS,
    [DocumentRequirementStatusType.Cancelled]:
        TRANSLATION_DOC_CHECKLIST_STATUS_CANCELLED,
};
